/**
 * Store: Quick add to cart
 * -----------------------------------------------------------------------------
 * Handles quick add to cart actions
 */

export default {
  namespaced: true,

  state: () => ({
    lastAddedProductId: false,
    product: false,
    size: false,
    isUpdatedSuccess: false,
  }),

  getters: {

    /**
     * Get the current active product for ATC
     * @returns {Object}
     */
    getCurrentProduct(state) {
      return state.product
    },
  },

  mutations: {

    /**
     * Set product.
     */
    SET_PRODUCT(state, product) {
      state.product = product
    },

    /**
     * Set selected product size
     */
    SET_SIZE(state, size) {
      state.size = size
    },

    /**
     * Set selected product size
     */
    SET_ADD_FROM_PLP(state, isUpdatedSuccess) {
      state.isUpdatedSuccess = isUpdatedSuccess
    },

    /**
     * Set last added product id
     */
    SET_LAST_ADDED(state, id) {
      state.lastAddedProductId = id
    },
  },

  actions: {

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setQuickAddProduct({ commit }, product = false) {
      commit('SET_PRODUCT', product)
    },

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setSize({ commit }, size = false) {
      commit('SET_SIZE', size)
    },

    /**
      * Set product data.
      * @param {Object} product - Product object.
      */
    setUpdatedSuccess({ commit }, isUpdatedSuccess = false) {
      commit('SET_ADD_FROM_PLP', isUpdatedSuccess)
    },

    /**
     * Set last added product id
     * @param {*} id - product ID
     */
    setLastAdded({ commit }, id = false) {
      commit('SET_LAST_ADDED', id)

      setTimeout(() => {
        commit('SET_LAST_ADDED', false)
      }, 3000)
    },
  },
}
